module.exports = __webpack_public_path__ + "static/media/whey.69b0c445.png";